"use client"

import { MessageSquarePlus } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MessageSquarePlusIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MessageSquarePlusIcon = component(Icon)({ as: MessageSquarePlus })
